import React, { useState, useEffect } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";

import UseCotizador from "./hooks/UseCotizador";
import SelectFields from "./SelectFields";

import Swal from "sweetalert2";
import LoaderModal from "./modals/LoaderModal";

import ReCaptcha from "./ReCaptcha";

//import fullBrands from "../moks/data_brands_full";

const YEARS_BEFORE = 10;

export default function Cotizador() {
  const [marcaSeleccionada, setMarcaSeleccionada] = useState(null);
  const [modeloSeleccionado, setModeloSeleccionado] = useState(null);
  const [anioSeleccionado, setAnioSeleccionado] = useState(null);
  // eslint-disable-next-line no-unused-vars
  const [versionSeleccionada, setVersionSeleccionada] = useState(null);
  // eslint-disable-next-line no-unused-vars
  const [kilometrajeSeleccionado, setKilometrajeSeleccionado] = useState(null);
  const [datosPersonales, setDatosPersonales] = useState({
    correo: "",
    telefono: "",
    nombre: "",
    apellido: "",
  });
  const [prendaSeleccionada, setPrendaSeleccionada] = useState(null);

  const [modelos, setModelos] = useState([]);
  const [years, setYears] = useState([]);

  const [submitData, setSubmitData] = useState([]);

  const [validCaptcha, setValidCaptcha] = useState(false);

  const {
    brands,
    getVersions,
    versions,
    setVersions,
    postSubmitData,
    showLoader,
  } = UseCotizador();

  const handleValidCaptcha = (value) => {
    //console.log("captcha", value);
    setValidCaptcha(value);
  };

  const handleMarcaSeleccionada = (marcaSeleccionada) => {
    setMarcaSeleccionada(marcaSeleccionada.value);
    setSubmitData({ ...submitData, marca: marcaSeleccionada.name });

    setModeloSeleccionado(null);
    setAnioSeleccionado(null);
    setVersionSeleccionada(null);

    setModelos([]);
    setYears([]);
    setVersions([]);
  };

  const handleModeloSeleccionado = (modeloSeleccionado) => {
    setModeloSeleccionado(modeloSeleccionado.value);
    setSubmitData({ ...submitData, modelo: modeloSeleccionado.name });

    setAnioSeleccionado(null);
    setVersionSeleccionada(null);

    setYears([]);
    setVersions([]);
  };

  const handleAnioSeleccionado = (anio) => {
    setAnioSeleccionado(anio.value);
    setSubmitData({ ...submitData, anio: anio.name });

    setVersionSeleccionada(null);

    setVersions([]);
    getVersions(marcaSeleccionada, modeloSeleccionado, anio.value);
  };

  const removeDoubleSpaces = (text) => {
    return text.replace(/\s+/g, " ");
  };

  const handleVersionSeleccionada = (versionSeleccionada) => {
    setVersionSeleccionada(versionSeleccionada.value);
    setSubmitData({
      ...submitData,
      version: removeDoubleSpaces(versionSeleccionada.name),
      codia: versionSeleccionada.value,
    });
  };

  const handleKilometrajeSeleccionado = (kilometrajeSeleccionado) => {
    setKilometrajeSeleccionado(kilometrajeSeleccionado.value);
    setSubmitData({
      ...submitData,
      kilometraje: parseInt(kilometrajeSeleccionado.value),
    });
  };

  const handlePrendaSeleccionada = (prendaSeleccionada) => {
    setPrendaSeleccionada(prendaSeleccionada.value);
    setSubmitData({ ...submitData, prenda: prendaSeleccionada.value });
  };

  const rowStyle = "m-0 p-0";

  useEffect(() => {
    const filteredModels = [];

    for (const iterator of brands) {
      if (iterator.id === parseInt(marcaSeleccionada)) {
        filteredModels.push(iterator.groups);
      }
    }

    setModelos(filteredModels);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [marcaSeleccionada]);

  useEffect(() => {
    if (modeloSeleccionado) {
      getModelsYears();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modeloSeleccionado]);

  const getModelsYears = () => {
    const selectedBrand = brands.find((brand) => {
      // eslint-disable-next-line eqeqeq
      return brand.id == marcaSeleccionada;
    });

    const modelSelected = selectedBrand.groups.find(
      // eslint-disable-next-line eqeqeq
      (group) => group.id == modeloSeleccionado
    );

    const modelsYears = [];

    const today = new Date();

    const minFromYear = today.getFullYear() - YEARS_BEFORE;

    if (modelSelected) {
      for (
        let year =
          modelSelected.prices_from < minFromYear
            ? minFromYear
            : modelSelected.prices_from;
        year <= modelSelected.prices_to;
        year++
      ) {
        modelsYears.push({ name: year, id: year });
      }
    }

    setYears(modelsYears);
  };

  let kilometraje = [];

  for (let index = 0; index < 90000; ) {
    index = index + 10000;
    kilometraje.push({
      name: `${Intl.NumberFormat("es-AR", {
        currency: "ARS",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }).format(index)} kms`,
      id: index,
    });
  }

  /* kilometraje.unshift({
    name: "menos de 10.000 kms",
    id: "menos de 10.000 kms",
  }); */

  const handleInputChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;

    const newValue = { ...datosPersonales, [name]: value };

    setDatosPersonales(newValue);
    setSubmitData({ ...submitData, datosPersonales: newValue });
  };

  let prendavalues = [
    { name: "SI", id: "SI" },
    { name: "NO", id: "NO" },
  ];

  /* useEffect(() => {
    console.log("submitData", submitData);
  }, [submitData]); */

  const campos = [
    { campo: " marca ", valor: marcaSeleccionada },
    { campo: " modelo ", valor: modeloSeleccionado },
    { campo: " año ", valor: anioSeleccionado },
    { campo: " version ", valor: versionSeleccionada },
    { campo: " kilometraje ", valor: kilometrajeSeleccionado },
    { campo: " prenda ", valor: prendaSeleccionada },
  ];

  let errores = [];

  const removeError = (field) => {
    const errorIndex = errores.findIndex((error) => error === field);

    if (errorIndex >= 0) {
      //console.log("removing...", errores);
      errores.splice(errorIndex, 1, "algo", "mas");
      //console.log("after remove...", errores);
    }
  };

  const addError = (field) => {
    !errores.includes(field) && errores.push(field);
  };

  //console.log(errores, "errores");
  const testEmail = (email) => {
    function validateEmail(email) {
      const re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      if (re.test(String(email).toLowerCase()) === false) {
        addError(" correo ");
      } else {
        removeError(" correo ");
      }
    }

    validateEmail(datosPersonales.correo);
  };

  const testTelefono = (telefono) => {
    //console.log("entre", datosPersonales.telefono);
    function validateTelefono(telefono) {
      if (telefono.length < 8) {
        addError(" telefono ");
      } else {
        removeError(" telefono ");
      }
    }

    validateTelefono(datosPersonales.telefono);
  };

  const testNombre = (nombre) => {
    function validateNombre(nombre) {
      if (nombre.length < 4) {
        addError(" nombre ");
      } else {
        removeError(" nombre ");
      }
    }

    validateNombre(datosPersonales.nombre);
  };

  const testApellido = (apellido) => {
    function validateApellido(apellido) {
      if (apellido.length < 4) {
        addError(" apellido ");
      } else {
        removeError(" apellido ");
      }
    }

    validateApellido(datosPersonales.apellido);
  };

  const enviarDatos = () => {
    testEmail(datosPersonales.correo);
    testTelefono(datosPersonales.telefono);
    testNombre(datosPersonales.nombre);
    testApellido(datosPersonales.apellido);

    for (const iterator of campos) {
      if (iterator.valor === null) {
        errores.push(iterator.campo);
      }
    }

    if (errores.length > 0) {
      Swal.fire({
        title: "Para solicitar la cotizacion",
        html: `Los siguientes campos no pueden estar vacios o contienen errores: </br></br> <b>${errores}</b>`,
        icon: "error",
      });
      errores = [];
    } else {
      //console.log(submitData, "submitData");
      postSubmitData(submitData);
    }
  };

  return (
    <>
      <Container className={rowStyle}>
        <Row className={rowStyle}>
          <Col className="pt-5 pb-4 text-center" xs={12}>
            <img
              src="https://store.lenken.com.ar/img/imgSitio/logos/logoBig.png"
              width="200px"
              alt="logo empresa"
              className="pb-2"
            ></img>
            <h2>Cotizador Online</h2>
          </Col>
          <Row className={rowStyle}>
            <Col className="pb-4">
              <Card className="text-center">
                <Card.Header>
                  <h4>Bienvenido</h4>
                </Card.Header>
                <Card.Body>
                  <Card.Title>
                    Este es nuestro sistema de cotización online
                  </Card.Title>
                  <Card.Text>
                    A continuación selecciona los datos de tu auto, y completa
                    el formulario de contacto. <br></br>A la brevedad recibirás
                    una cotización y toda la información necesaria para que
                    puedas avanzar con la venta de tu vehículo usado.
                  </Card.Text>
                </Card.Body>
                <Card.Footer className="text-muted">Inicio</Card.Footer>
              </Card>
            </Col>
          </Row>
          <Row className={rowStyle}>
            <Col className="my-2" xs={12} md={{ span: 4, offset: 4 }}>
              <SelectFields
                data={brands}
                onSeleccionMessage="Selecciona la marca de tu vehiculo"
                OnLoadingMessage="Cargando..."
                onHandleSeleccion={handleMarcaSeleccionada}
              />
            </Col>
          </Row>
          <Row className={rowStyle}>
            <Col className="my-2" xs={12} md={{ span: 4, offset: 4 }}>
              {modelos.length > 0 && (
                <SelectFields
                  data={modelos[0]}
                  onSeleccionMessage="Selecciona el modelo"
                  OnLoadingMessage="Cargando..."
                  onHandleSeleccion={handleModeloSeleccionado}
                />
              )}
            </Col>
          </Row>
          <Row className={rowStyle}>
            <Col className="my-2" xs={12} md={{ span: 4, offset: 4 }}>
              {modeloSeleccionado && (
                <SelectFields
                  data={years}
                  onSeleccionMessage="Selecciona el año"
                  OnLoadingMessage="Cargando..."
                  onHandleSeleccion={handleAnioSeleccionado}
                />
              )}
            </Col>
          </Row>
          <Row className={rowStyle}>
            <Col className="my-2" xs={12} md={{ span: 4, offset: 4 }}>
              {anioSeleccionado && (
                <SelectFields
                  data={versions}
                  onSeleccionMessage="Selecciona la version"
                  OnLoadingMessage="Cargando..."
                  onHandleSeleccion={handleVersionSeleccionada}
                />
              )}
            </Col>
          </Row>
          <Row className={rowStyle}>
            <Col className="my-2" xs={12} md={{ span: 4, offset: 4 }}>
              {anioSeleccionado && (
                <SelectFields
                  data={kilometraje}
                  onSeleccionMessage="Ingresa el kilometraje"
                  onHandleSeleccion={handleKilometrajeSeleccionado}
                />
              )}
            </Col>
            <Row className={rowStyle}>
              <Col className="my-2" xs={12} md={{ span: 4, offset: 4 }}>
                {anioSeleccionado && (
                  <SelectFields
                    data={prendavalues}
                    onSeleccionMessage="Tiene prenda o plan de ahorro?"
                    onHandleSeleccion={handlePrendaSeleccionada}
                  />
                )}
              </Col>
            </Row>
          </Row>
        </Row>

        <Row className={rowStyle}>
          <Col
            className="text-center pt-4 pb-5"
            xs={12}
            md={{ span: 4, offset: 4 }}
          >
            <Form>
              <Form.Group className="mb-3">
                <Form.Label>Correo electronico</Form.Label>
                <Form.Control
                  type="email"
                  placeholder="Ingresa tu correo electronico"
                  name="correo"
                  onChange={handleInputChange}
                />
                <Form.Text className="text-muted">
                  Importante, la cotización será enviada a esta dirección.
                </Form.Text>
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Telefono</Form.Label>
                <Form.Control
                  type="number"
                  placeholder="Ingresa un telefono de contacto"
                  name="telefono"
                  onChange={handleInputChange}
                />
              </Form.Group>
              <Row>
                <Col xs={12} md={{ span: 6 }}>
                  <Form.Group className="mb-3">
                    <Form.Label>Nombre</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Ingresa tu Nombre"
                      name="nombre"
                      onChange={handleInputChange}
                    />
                  </Form.Group>
                </Col>
                <Col xs={12} md={{ span: 6 }}>
                  <Form.Group className="mb-3">
                    <Form.Label>Apellido</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Ingresa tu Apellido"
                      name="apellido"
                      onChange={handleInputChange}
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Col className="pt-5">
                <ReCaptcha onValidCaptcha={handleValidCaptcha} />
                <Button
                  variant="primary"
                  onClick={enviarDatos}
                  disabled={validCaptcha ? false : true}
                >
                  Solicitar Cotización
                </Button>
              </Col>
            </Form>
          </Col>
        </Row>
        <footer className="bg-light text-center text-lg-start">
          <div
            className="text-center p-3 pb-4"
            style={{ backgroundColor: "rgba(0, 0, 0, 0.2)" }}
          >
            © 2021 Copyright <b>Lenken</b>
          </div>
        </footer>
      </Container>
      <LoaderModal show={showLoader} />
    </>
  );
}
